import { api, ReactQueryOptions, RouterInputs, RouterOutputs } from '@api'
import { UseTRPCInfiniteQueryOptions } from '@trpc/react-query/shared'
import { TRPCClientErrorLike } from '@trpc/client'

type inputType = RouterInputs['ToyManager']['getDrafts']
type queryOptionsType = ReactQueryOptions['ToyManager']['getDrafts']
type outputType = RouterOutputs['ToyManager']['getDrafts']
type optionsType = UseTRPCInfiniteQueryOptions<'ToyManager.getDrafts', inputType, outputType, TRPCClientErrorLike<any>>

export const useGetDraftsInfinity = (input: inputType, options?: optionsType) =>
    api.ToyManager.getDrafts.useInfiniteQuery(input, {
        ...options,
        queryKey: ['ToyManager.getDrafts', input],
        getNextPageParam: (firstPage) => firstPage.nextCursor,
        initialCursor: undefined,
        staleTime: 15 * 60 * 1000, // 15 mins
    })

export const useGetDrafts = (input: inputType, options?: queryOptionsType) =>
    api.ToyManager.getDrafts.useQuery(input, {
        ...options,
        queryKey: ['ToyManager.getDrafts', input],
        staleTime: 15 * 60 * 1000, // 15 mins
    })
